
/*  eslint-disable  */
'use strict'
import { ValidateEmail } from "utils/string";
//Variables to change in your deployment

const initNewForm = () => {
    const livechatTrigger = document.querySelector('#livechat-form-trigger');
    const deploymentId = livechatForm.dataset.livechatId;

    // Form Elements
    const form = livechatForm.querySelector('#livechat-start-form');
    const submitButton = livechatForm.querySelector('.submit-btn');
    const cancelButton = livechatForm.querySelector('.cancel-btn');
    const closeFormButton = livechatForm.querySelector('.close-form-btn');
    const nameInputElement = livechatForm.querySelector(".name-input");
    const emailInputElement = livechatForm.querySelector(".email-input");
    const subjectInputElement = livechatForm.querySelector(".subject-input");

    // Close chat confirm elements
    const closeChatConfirmMessage = livechatForm.querySelector('.form-close-confirm-wrapper');
    const closeChatConfirmCloseBtn = closeChatConfirmMessage.querySelector('.submit-btn');
    const closeChatConfirmCancelBtn = closeChatConfirmMessage.querySelector('.cancel-btn');
    const url = livechatForm.dataset.livechatUrl;

    const resetInputs = () => {
        emailInputElement.querySelector('input').value = '';
        emailInputElement.classList.remove('error');
        nameInputElement.querySelector('input').value = '';
        nameInputElement.classList.remove('error');
        subjectInputElement.querySelector('input').value = '';
    }

    const openChatForm = () => {
        livechatTrigger.classList.remove('visible');
        livechatForm.classList.add('visible');
    }

    const closeChatForm = (showTrigger) => {
        resetInputs();
        livechatTrigger.classList.add('visible');
        if (showTrigger) {
            livechatForm.classList.remove('visible');
        }
    }

    const toggleCloseChatConfirm = () => {
        closeChatConfirmMessage.classList.toggle('visible');
    }

    // Load Genesys - script taken from client.
    (function (g, e, n, es, ys) {
        g['_genesysJs'] = e;
        g[e] = g[e] || function () {
            (g[e].q = g[e].q || []).push(arguments)
        };
        g[e].t = 1 * new Date();
        g[e].c = es;
        ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);
    })(window, 'Genesys', 'https://apps.mypurecloud.com.au/genesys-bootstrap/genesys.min.js', {
        environment: 'prod-apse2',
        deploymentId: deploymentId,
    });


    const openGenesysChat = () => {
        const formData = new FormData(form);
        const nameInput = form.querySelector(".name-input");
        const emailInput = form.querySelector(".email-input");
        const invalidInputs = !formData.get('name') || (formData.get('email') && !ValidateEmail(formData.get('email')));

        const validateInputs = () => {
            if (!formData.get('name')) {
                nameInput.classList.add('error');
            } else {
                nameInput.classList.remove('error');
            }

            // Email is not mandatory - but validate email if there's
            if (formData.get('email') && !ValidateEmail(formData.get('email'))) {
                emailInput.classList.add('error');
            } else {
                emailInput.classList.remove('error');
            }
        }

        validateInputs();

        if (invalidInputs) {
            return;
        }

        closeChatForm();

        const data = {
            name: formData.get('name'),
            email: formData.get('email'),
            subject: formData.get('subject'),
        }

        Genesys("command", "Messenger.open", {},
            function (o) {
                Genesys("command", "Database.set", {
                    messaging: {
                        customAttributes: {
                            ...data,
                            URL: url
                        }
                    }
                });
            },  // if resolved
            function (o) {    // if rejected
                Genesys("command", "Messenger.close");
            }
        );
    }

    const onGenesysReady = () => {
        livechatTrigger.classList.add('visible');
    }

    Genesys(
        'subscribe',
        'Messenger.ready',
        () => (onGenesysReady())
    );

    // Expected "Message Us" button behavior:
    // when the conversation is cleared, restart the form.
    // if existing chat exists, re-open previous chat.
    // Docs : https://developer.genesys.cloud/commdigital/digital/webmessaging/messengersdk/SDKCommandsEvents/messagingServicePlugin#messagingservice-conversationcleared

    Genesys('subscribe', 'Messenger.opened', () => {
        livechatTrigger.classList.remove('visible')
        livechatForm.classList.remove('visible')
    });

    // Show the trigger when messenger is closed
    Genesys('subscribe', 'Messenger.closed', () => {
        livechatTrigger.classList.add('visible');
    });


    // check if there's any previous chat. if there are, open the chat.
    // if not, open the chat form.
    livechatTrigger?.addEventListener('click', (e) => {
        e.preventDefault();
        let session = JSON.parse(localStorage.getItem(`_${deploymentId}:gcmcsessionActive`))
        if (session) {
            Genesys("command", "Messenger.open")
        } else {
            openChatForm();
        }
    })

    submitButton?.addEventListener('click', (e) => {
        e.preventDefault();
        openGenesysChat();
    })

    closeFormButton?.addEventListener('click', (e) => {
        e.preventDefault();
        toggleCloseChatConfirm();
    })

    cancelButton?.addEventListener('click', (e) => {
        e.preventDefault();
        toggleCloseChatConfirm();
    })

    closeChatConfirmCloseBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        toggleCloseChatConfirm();
        closeChatForm(true);
    })

    closeChatConfirmCancelBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        toggleCloseChatConfirm();
    })
}

const livechatForm = document.querySelector('#livechat-form');

if (livechatForm) {
    const formVersion = livechatForm.dataset.formVersion;
    if (formVersion === 'new') {
        initNewForm();
    }
}